import React from 'react';
import ReactDOM from 'react-dom/client';
import Alert from '../components/Alert';

let alertContainer = null;

const createAlertContainer = () => {
  if (!alertContainer) {
    const div = document.createElement('div');
    div.id = 'alert-container';
    document.body.appendChild(div);
    alertContainer = ReactDOM.createRoot(div);
  }
  return alertContainer;
};

const showAlert = (message, type = 'info', duration = 5000) => {
  const container = createAlertContainer();
  
  const AlertComponent = () => {
    const [show, setShow] = React.useState(true);

    if (!show) return null;

    return (
      <Alert
        message={message}
        type={type}
        duration={duration}
        onClose={() => setShow(false)}
      />
    );
  };

  container.render(<AlertComponent />);
};

export const alert = {
  success: (message, duration) => showAlert(message, 'success', duration),
  error: (message, duration) => showAlert(message, 'error', duration),
  warning: (message, duration) => showAlert(message, 'warning', duration),
  info: (message, duration) => showAlert(message, 'info', duration),
};

export default alert;



